export const SANS =
  "-apple-system, BlinkMacSystemFont, 'SF Pro Text', 'Segoe UI', sans-serif";
export const DISPLAY_SERIF = "'Bitter', Georgia, serif";
